import { PageHero, useTitle } from "../components/PageHero";
import { Reveal, Tag } from "../components/Reveal";
import { PrimaryBtn } from "../components/ui";
import { CTABand } from "../components/CTABand";
import { PROJECTS, PROJECTS_NOTE } from "../data/projects";
import { IMG } from "../data/site";

const Row = ({ label, value }) => (
  <div className="grid gap-1 border-t border-seam/60 py-3 sm:grid-cols-[160px_1fr] sm:gap-6">
    <span className="font-mono text-[10px] uppercase tracking-widest text-spark">{label}</span>
    <span className="text-sm leading-relaxed text-cadmium">{value}</span>
  </div>
);

export default function Projects() {
  useTitle("Projects & Case Studies | SABAKT Saudi Arabia");
  return (
    <main>
      <PageHero image={IMG.excavator2} eyebrow="Projects & Case Studies" testid="projects-hero"
        title="Requirement. Challenge. Solution. Result." accent="Solution."
        text="Not an image gallery — structured case studies showing how SABAKT approaches industrial problems across the Kingdom." />

      <div className="border-b border-seam bg-gold/10 px-4 py-4 sm:px-8 lg:px-16" data-testid="projects-verify-note">
        <p className="mx-auto max-w-7xl font-mono text-[11px] uppercase tracking-wider text-gold">
          {PROJECTS_NOTE}
        </p>
      </div>

      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-7xl space-y-16 px-4 sm:px-8 lg:px-16">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.slug}>
              <article data-testid={`project-${p.slug}`} className="grid overflow-hidden border border-seam lg:grid-cols-[420px_1fr]">
                <div className="relative min-h-64 overflow-hidden">
                  <img src={p.image} alt={p.title} className="absolute inset-0 h-full w-full object-cover" />
                  <span className="absolute left-4 top-4 bg-obsidian/85 px-3 py-1.5 font-mono text-[10px] uppercase tracking-widest text-spark">
                    Case {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="bg-iron p-8 lg:p-10">
                  <Tag>{p.industry} · {p.location}</Tag>
                  <h2 className="mt-3 font-display text-2xl font-extrabold uppercase tracking-tight text-frost lg:text-3xl">{p.title}</h2>
                  <div className="mt-6">
                    <Row label="Requirement" value={p.requirement} />
                    <Row label="Challenge" value={p.challenge} />
                    <Row label="SABAKT Solution" value={p.solution} />
                    <Row label="Materials / Tech" value={p.materials} />
                    <Row label="Scope" value={p.scope} />
                    <Row label="Result" value={p.result} />
                  </div>
                  <div className="mt-6">
                    <PrimaryBtn to="/rfq" testid={`project-similar-${p.slug}`}>Similar Solution for My Plant</PrimaryBtn>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand title="Your Project Could Be Next."
        text="Send the requirement — drawings, photos, or a description of the failure. Our engineering team will respond with an approach, not just a price." />
    </main>
  );
}
